import { Button, Input, List, Space, Tag, Avatar, Typography, Alert } from 'antd';
import React, { useEffect, useState } from 'react'
import { useAxios } from '../../nextgen/service/useAxios';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { localizeField } from '../../nextgen/utils/localization';
import {
  ApartmentOutlined,
  AppstoreOutlined,
  AuditOutlined,
  CarOutlined,
  FileDoneOutlined,
  FormOutlined,
  ReconciliationOutlined,
  ShareAltOutlined,
} from '@ant-design/icons';

const { Search } = Input;
const { Text } = Typography;

export default function FullTextSearch({ closeModal }) {

  const [searchResult, setSearchResult] = useState(null);
  const [alertMsg, setAlertMsg] = useState(null);
  const [formSchemaMap, setFormSchemaMap] = useState({});

  const history = useHistory();
  const axiosInstance = useAxios();
  const { i18n, t } = useTranslation();

  useEffect(() => {
    axiosInstance.request({
      url: '/api/form-schema',
      method: 'GET',
    }).then((response) => {
      const map = {};
      response.data.forEach(fs => {
        map[fs.id] = fs;
      });
      setFormSchemaMap(map);
    });
  }, []);

  const onSearch = (value) => {
    if (value.length <= 3) {
      setAlertMsg(t('search.minCharError'))
      return;
    } else {
      setAlertMsg(null)
    }
    axiosInstance.request({
      url: '/api/search',
      params: { q: value },
      method: 'GET',
    }).then((response) => {
      setSearchResult(response.data)
    })
  }

  function getPath(item) {
    if (item.type === "OBJECT") {
      return "/save-object/" + item.entityId
    } else if (item.type === "CONDITION") {
      return "/save-condition/" + item.entityId
    } else if (item.type === "CURATORIAL_FORM") {
      return "/save-curatorial-form/" + item.entityId
    } else if (item.type === "TECHNICAL_FORM") {
      return "/save-technical-form/" + item.entityId
    } else if (item.type === "MOVEMENT") {
      return "/save-movement/" + item.entityId
    } else if (item.type === "TREATMENT") {
      return "/save-treatment/" + item.entityId
    } else if (item.type === "INSURANCE") {
      return "/save-insurance/" + item.entityId
    } else if (item.type === "CUSTOM_REPORT") {
      return `/custom-form-add/${item.formId}/${item.entityId}`
    }
    return "/#"
  }

  const getAvatar = (type) => {
    if (type === "OBJECT") {
      return <Avatar icon={<AppstoreOutlined />} />
    } else if (type === "CONDITION") {
      return <Avatar icon={<ReconciliationOutlined />} />
    } else if (type === "CURATORIAL_FORM") {
      return <Avatar icon={<ApartmentOutlined />} />
    } else if (type === "TECHNICAL_FORM") {
      return <Avatar icon={<CarOutlined />} />
    } else if (type === "MOVEMENT") {
      return <Avatar icon={<ShareAltOutlined />} />
    } else if (type === "TREATMENT") {
      return <Avatar icon={<AuditOutlined />} />
    } else if (type === "INSURANCE") {
      return <Avatar icon={<FileDoneOutlined />} />
    } else if (type === "CUSTOM_REPORT") {
      return <Avatar icon={<FormOutlined />} />
    }
    return <Avatar />
  }

  function getDescription(item) {
    return <p>{item?.context?.preText}
      <Text mark>{item?.context?.foundText}</Text>
      {item?.context?.postText}
    </p>;
  }

  function getTagLabel(item) {
    if (item.type === "CUSTOM_REPORT") {
      const formSchema = formSchemaMap[item.formId];
      return formSchema ? localizeField(formSchema.name) : item.type;
    }
    return t('search.type.' + item.type, item.type);
  }

  const getActionButton = (item) => {
    const onClick = () => {
      closeModal();
      const path = getPath(item);
      console.log(path)
      history.push(getPath(item));
    }
    return [
      <Button key={`${item.type}-${item.entityId}`} onClick={onClick}>
        {t('search.view')}
      </Button>
    ];
  }

  return (
    <div>
      <Search size="large" placeholder={t('search.placeholder')} onSearch={onSearch} />
      {alertMsg && <Alert message={alertMsg} type="error" style={{ marginTop: 16 }} />}

      <div style={{ overflowY: 'auto', maxHeight: 600, padding: 24 }}>
        {searchResult &&
          <List
            itemLayout="horizontal"
            dataSource={searchResult}
            pagination={{ pageSize: 30 }}
            renderItem={item => (
              <List.Item key={`${item.type}-${item.entityId}`} actions={getActionButton(item)}>
                <List.Item.Meta
                  avatar={getAvatar(item.type)}
                  title={<Space><Tag>{getTagLabel(item)}</Tag>{item.entityName}</Space>}
                  description={getDescription(item)}
                />
              </List.Item>
            )}
          />}
      </div>
    </div>
  )
}
